export default __webpack_public_path__ + "static/media/13t.250e7ace.jpg";